import React from 'react'
import '../sass/Header.scss'

const Heading = () => {
    return (
        <div className="header">
            <h1>kanban Board</h1>
        </div>
    )
}

export default Heading
